module.exports = __webpack_public_path__ + "static/media/balinese_temple_bw_left.e18efd73.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/balinese_temple_bw_left.png
// module id = 45
// module chunks = 0